/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ClearPinRateLimit_user = {
    readonly id: string;
    readonly devices: ReadonlyArray<{
        readonly deviceId: string;
        readonly deviceModel: string;
        readonly deviceName: string;
        readonly hasPinRateLimitBlock: boolean;
    }> | null;
    readonly " $refType": "ClearPinRateLimit_user";
};
export type ClearPinRateLimit_user$data = ClearPinRateLimit_user;
export type ClearPinRateLimit_user$key = {
    readonly " $data"?: ClearPinRateLimit_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ClearPinRateLimit_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClearPinRateLimit_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserDevice",
      "kind": "LinkedField",
      "name": "devices",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceModel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPinRateLimitBlock",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '9ddecdc7132e7df7b76a3c695334185f';
export default node;
